import cx from "classnames";

import { useAuthentication } from "common/auth/hooks";

import { useClinic } from "client/clinics/hooks";
import Header from "client/common/components/header/Header";

import { HomeThemeProps } from "../types";
import HomeContent from "./HomeContent";
import LoggedInWelcomeSummary from "./LoggedInWelcomeSummary";

import styles from "../styles/HomeThemeDefault.module.less";

const HomeThemeDefault = ({ storefrontThemeConfig }: HomeThemeProps) => {
  const clinic = useClinic();
  const { isAuthenticated } = useAuthentication();
  const { logo } = storefrontThemeConfig;

  const renderDefaultHeaderContent = () => (
    <div className={styles.defaultHeaderContent}>
      <HomeContent.Title lineColors={["#BECEA6", "#91B8E1", "#B0A9D4"]} />
      <div className={styles.description}>
        Your animal&apos;s health is our top priority at {clinic.display_name}. We&apos;ve made it
        even easier to refill and request new medications through our online store.
      </div>
    </div>
  );
  return (
    <div>
      <Header storefrontThemeLogo={logo} />
      <HomeContent.Header>
        <div className={styles.headerContainer}>
          <div className={styles.label}>
            {isAuthenticated ? "Welcome back!" : "Welcome to our new home delivery portal"}
          </div>
          {isAuthenticated ? (
            <LoggedInWelcomeSummary DefaultSummaryHeader={renderDefaultHeaderContent()} />
          ) : (
            renderDefaultHeaderContent()
          )}
        </div>
      </HomeContent.Header>
      <div>
        <div className={cx(styles.gradient, styles.one)} />
        <div className={cx(styles.gradient, styles.two)} />
        <div className={cx(styles.gradient, styles.three)} />
        <div className={cx(styles.gradient, styles.four)} />
        <div className={cx(styles.gradient, styles.five)} />
      </div>
      <HomeContent.Body hasLoggedinSummary={false} />
    </div>
  );
};

export default HomeThemeDefault;
